import { flowTwoWinsThenLose } from "./flow_two_wins_then_lose";
import { flowImmediateLose } from "./flow_immediate_lose";
import { flowTripleWin } from "./flow_triple_win";
import type { GambleFlow } from "@slot/game-shell";

/**
 * Gamble flows cycled by ScriptedRoundProvider.
 * Order here determines the round-robin cycle.
 */
export function createGambleFlows(): GambleFlow[] {
  return [
    flowTwoWinsThenLose,
    flowImmediateLose,
    flowTripleWin,
  ];
}
